module.exports = __webpack_public_path__ + "img/art-inside-banner.500a589f.png";